import { render } from "./cardsGeralRedirectionsComponent.vue?vue&type=template&id=4a018bb5&scoped=true"
import script from "./cardsGeralRedirectionsComponent.vue?vue&type=script&lang=js"
export * from "./cardsGeralRedirectionsComponent.vue?vue&type=script&lang=js"

import "./cardsGeralRedirectionsComponent.vue?vue&type=style&index=0&id=4a018bb5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a018bb5"]])

export default __exports__